import axios, {Axios} from 'axios';
import {notifyVerificationRequired} from '@utils/verification';
import {useAppDispatch, useAppSelector} from '@hooks/app';
import {useMemo} from 'react';
import {setBackendAvailable} from '@store/app.slice';
import {devBaseUrl, prodBaseUrl} from '../api';

export const useAuthAxios = (): Axios => {
  const {token, token_type} = useAppSelector(state => state.app.token || {token: '', token_type: ''});
  const dispatch = useAppDispatch();

  return useMemo(() => {
    const instance = axios.create({
      baseURL: process.env.NODE_ENV === 'development' ? devBaseUrl : prodBaseUrl,
      // добавлено: таймаут, чтобы недоступность бэка реально отлавливалась
      timeout: 20000,
      headers: {
        Accept: 'application/json',
        ...(token ? {Authorization: `${token_type} ${token}`} : {}),
      },
    });

    instance.interceptors.response.use(
      response => {
        dispatch(setBackendAvailable(true));
        return response;
      },
      error => {
        notifyVerificationRequired(error?.response?.status, error?.response?.data);
        // таймаут / сетевая ошибка
        const isTimeoutOrNetwork = error?.code === 'ECONNABORTED' || error?.code === 'ERR_NETWORK';
        // нет ответа от сервера
        const noResponse = !error?.response;
        // сервер недоступен
        const isServerDown = error?.response && [502, 503, 504].includes(error.response.status);

        if (isTimeoutOrNetwork || noResponse || isServerDown) {
          dispatch(setBackendAvailable(false));
        }
        // остальные ошибки (400/401/403/404/422/500 с ответом) — обычные бизнес-ошибки, флаг не трогаем

        return Promise.reject(error);
      }
    );

    return instance;
  }, [token, token_type, dispatch]);
};
